import Collection from 'src/components/common/card/collection';
import { DeleteCollectionModal } from 'src/app/label/components/delete-label';
import { useDisclosure } from '@chakra-ui/react';
import is from 'is_js';
import { useState } from 'react';
import { logger } from 'src/lib/logger';
import { useFeaturedCollectionMutation } from 'src/app/label/hooks';

interface Props {
  data: Array<Object>;
  className?: string;
  fns?: Array<string>;
}

interface Props {
  projectId: string;
  data: Array<Object>;
  className?: string;
  fns?: Array<string>;
}

const Collections = ({ projectId, data, className = '', fns = [] }: Props) => {
  const deleteCollectionModal = useDisclosure();
  const { mutate: featuredCollection } = useFeaturedCollectionMutation(
    projectId
  );

  const featureHandel = async (collectionId) => {
    try {
      await featuredCollection({ rid: projectId, labelID: collectionId * 1 });
    } catch (err) {
      logger.error(err);
    }
  };

  const funcitons = {
    edit: {
      name: 'Edit collection',
      fn: () => {},
    },
    remove: {
      name: 'Remove this collection from the REPPL',
      fn: (e) => {
        const collectionId = e.target.getAttribute('data-id');
        setDeleteCollectionId(collectionId);
        deleteCollectionModal.onOpen();
      },
    },
    feature: {
      name: 'Feature collection',
      fn: (e) => {
        const collectionId = e.target.getAttribute('data-id');
        featureHandel(collectionId);
      },
    },
    rmfeatured: {
      name: 'Remove Featured',
      fn: (e) => {
        const collectionId = e.target.getAttribute('data-id');
        featureHandel(collectionId);
      },
    },
  };

  const actions = [];
  if (is.not.empty(fns)) {
    fns.forEach((fnKey, key) => {
      actions.push({
        id: key,
        type: 'click',
        displayName: funcitons[fnKey].name,
        icon: '',
        action: funcitons[fnKey].fn,
      });
    });
  }
  const [deleteCollectionId, setDeleteCollectionId] = useState(null);

  return (
    <>
      {data.map((d) => {
        return (
          <Collection
            className={className}
            data={d}
            key={d['id']}
            fns={actions}
          />
        );
      })}
      <DeleteCollectionModal
        {...deleteCollectionModal}
        type="REPPL"
        cid={deleteCollectionId}
        isCollectionOwner={fns.includes('remove')}
        onClose={() => {
          setDeleteCollectionId(null);
          deleteCollectionModal.onClose();
        }}
      />
    </>
  );
};

export default Collections;
